module.exports = __webpack_public_path__ + "img/欢喜首映.177b4acb.png";